var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.splitNum),function(char,index){return _c('div',{staticStyle:{"display":"inline-block"}},[(!isNaN(char))?_c('div',{staticClass:"box-item"},[_c('span',{ref:"numberItem",refInFor:true,style:({transform: `translate(-50%, -${Number(char) * 10}%)`})},[_vm._v("0123456789")])]):_c('span',{staticClass:"point"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }